import React from "react";

const PencilEditIcon = ({ height = 13, width = 13, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 13 13"
    fill="none"
    className={className}
  >
    <path
      d="M7.49194 2.34961L10.1587 5.01635"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M4.82548 10.3501L1.09204 11.4168L2.15874 7.68339L8.77972 1.06241C9.19626 0.645864 9.87148 0.645864 10.288 1.06241L11.4465 2.22084C11.863 2.63738 11.863 3.3126 11.4465 3.72915L4.82548 10.3501Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square"
    />
  </svg>
);

export default PencilEditIcon;
